import React, { PureComponent } from 'react';
import { FormControl } from 'react-reactive-form';

interface GenericInputProps extends FormControl {
  type?: 'text' | 'number';
}

class GenericInput extends PureComponent<GenericInputProps> {

  render() {
    return (
      <input
          placeholder={this.props.meta.placeholder ? this.props.meta.placeholder : ''}
        {...this.props.handler()}
        type={this.props.type ?? 'text'}
        disabled={this.props.disabled || false}
        className={`form-input form-control${this.props.status === 'INVALID' && this.props.submitted ? ' is-invalid' : ''}`}
      />
    );
  }

}

export const TextInput = (props: any) => <GenericInput {...props} type="text" />;
export const NumberInput = (props: any) => <GenericInput {...props} type="number"/>;
export const PasswordInput = (props: any) => <GenericInput {...props} type="password" />;
